import React, { FC, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { palette } from 'src/Theme';
import ShsSelectInput from 'src/components/common/Fields/ShsSelectInput';
import { useScheduleCalendarContext } from '../../common/context/CalendarContext';
import { Hospital } from 'src/components/Employees/types';
import { useFormContext } from 'react-hook-form';

export const ScheduleEducationCentersTeacher: FC = () => {
    const [hospitals, setHospitals] = useState<Array<{ id: string | number; name: string }>>([]);
    const { calendarData, setCalendarData } = useScheduleCalendarContext();
    const { setValue } = useFormContext();

    useEffect(() => {
        const choices = (calendarData?.educationCenter?.hospitals ?? []).map((hospital: Hospital, idx: number) => ({
            id: hospital.id ?? idx,
            name: hospital.name
        }));
        setHospitals(choices);

        if (calendarData.educationCenter?.hospitals?.length === 1) {
            const only = calendarData.educationCenter?.hospitals[0];
            setCalendarData((value) => ({ ...value, hospital: only }));
            setValue('hospital', only?.id);
        } else {
            setCalendarData((value) => ({ ...value, hospital: undefined }));
        }
    }, [calendarData.educationCenter]);

    const handleHospitalChange = (e: any) => {
        const id = e?.target?.value;
        const sel = calendarData.educationCenter?.hospitals.find((h) => String(h.id) === String(id));
        setCalendarData((value) => ({ ...value, hospital: sel }));
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    gap: '20px',
                    marginRight: '20px',
                    '& .text_field__label': {
                        fontWeight: 400,
                        fontSize: '11px',
                        lineHeight: '14px',
                        color: palette.primary.grayBluish
                    }
                }}>
                <ShsSelectInput
                    sx={{
                        width: '280px',
                        '.MuiInputBase-root': {
                            height: '40px',
                            fontSize: '14px',
                            '.MuiInputBase-input': {
                                display: 'flex',
                                alignItems: 'center',
                                height: '40px',
                                paddingBottom: 0,
                                paddingTop: 0
                            }
                        }
                    }}
                    disabled={!calendarData.educationCenter}
                    source="hospital"
                    label="Лікарня"
                    choices={hospitals}
                    onChange={handleHospitalChange}
                    filter=""
                    autoFocus
                    required
                    isTruncatedOptions
                />
            </Box>
        </>
    );
};
